import { Button, Card, CardContent, Grid } from '@material-ui/core'
import { useEffect, useState } from 'react'
import defaultImage from '../../../assets/img/default-machine.png'
import AddEditMachine from '../../Machine/AddEditMachine'
import ModalPopUp from '../../ModalPopUp/ModalPopUp'
import ToastMessage from '../../ToastMessage/ToastMessage'

interface MachineSummaryProps {
  machine: Machine
}

const MachineSummary = ({ machine }: MachineSummaryProps) => {
  const [thumbnailImage, setThumbnailImage] = useState('')
  const [showEditMachine, setShowEditMachine] = useState(false)
  const [toast, setToast] = useState(false)

  useEffect(() => {
    const getThumbnail = async () => {
      try {
        setThumbnailImage(
          `${process.env.REACT_APP_API}/api/thumbnail/${machine.thumbnail.id}`
        )
      } catch (error) {
        console.error(error)
      }
    }

    if (
      machine &&
      Object.keys(machine).length !== 0 &&
      machine.thumbnail &&
      Object.keys(machine.thumbnail).length !== 0 &&
      machine.thumbnail.id !== ''
    ) {
      getThumbnail()
    }
  }, [machine])

  return (
    <>
      <Card className="summary-card">
        <div className="flex space-between header align-center">
          <strong>Machine | {machine.name}</strong>

          <Button color="primary" onClick={() => setShowEditMachine(true)}>
            <span className="underline"> Edit</span>
          </Button>
        </div>

        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <div
                className={thumbnailImage ? 'has-thumbnail' : 'no-thumbnail'}
              >
                <div
                  className={`thumbnail`}
                  style={{
                    backgroundImage: `url(${thumbnailImage ? thumbnailImage : defaultImage
                      })`,
                  }}
                ></div>
              </div>
            </Grid>

            <Grid item xs={9}>
              <Grid container className="items">
                <Grid item xs={3}>
                  Serial number
                </Grid>
                <Grid item xs={9}>
                  {machine.serialNum}
                </Grid>
                <Grid item xs={3}>
                  Software version
                </Grid>
                <Grid item xs={9}>
                  {machine.softwareVersion}
                </Grid>
                <Grid item xs={3}>
                  Make
                </Grid>
                <Grid item xs={9}>
                  {machine.make}
                </Grid>

                <Grid item xs={3}>
                  Model
                </Grid>
                <Grid item xs={9}>
                  {machine.model}
                </Grid>

                <Grid item xs={3}>
                  Tool changer
                </Grid>
                <Grid item xs={9}>
                  {machine.toolChanger ? 'Yes' : 'No'}
                </Grid>

                <Grid item xs={3}>
                  Wrist make
                </Grid>
                <Grid item xs={9}>
                  {machine.wristMake}
                </Grid>

                <Grid item xs={3}>
                  Wrist angle
                </Grid>
                <Grid item xs={9}>
                  {machine.wristAngle && <>{machine.wristAngle} deg </>}
                </Grid>

                <Grid item xs={3}>
                  Additional notes
                </Grid>
                <Grid item xs={9}>
                  {machine.additionalNotes}
                </Grid>
              </Grid>

              <div className="strong m-t-24">Files</div>

              <Grid container className="items" spacing={0}>
                <Grid item xs={3}>
                  Additional documents
                </Grid>
                <Grid item xs={9}>
                  {machine.machineFiles &&
                    machine.machineFiles.map((file, index) => (
                      <div key={index}>{file.name}</div>
                    ))}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <ModalPopUp
        title="Edit machine"
        variant="full"
        setShowModal={setShowEditMachine}
        showModal={showEditMachine}
      >
        <AddEditMachine
          setMachineToEdit={setShowEditMachine}
          setShowAddMachine={setShowEditMachine}
          machineToEdit={machine}
        />
      </ModalPopUp>
      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">Machine updated</p>
            <p className="fs14 m-b-0">
              You successfully updated {machine.name}.
            </p>
          </>
        }
        open={toast}
        setOpen={setToast}
      />
    </>
  )
}

export default MachineSummary
